const emptyFn = () => {
};
const jsonParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.warn("jsonParse error:", e);
    return value;
  }
};
const sleep = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout));
};
const isValidValue = (value) => {
  if (value === 0) {
    return true;
  }
  if (value === null || value === void 0 || value === "" || value === "-") {
    return false;
  }
  if (typeof value === "string" && value.trim() === "") {
    return false;
  }
  if (typeof value === "number" && isNaN(value)) {
    return false;
  }
  return true;
};
export {
  emptyFn,
  isValidValue,
  jsonParse,
  sleep
};
